import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuthStore from 'store/auth';

const PublicRoute = ({ restricted }: { restricted: boolean }) => {
	const { token: isAuthenticated }: Record<string, any> = useAuthStore(
		(state) => state.userInfo ?? {},
	);

	const location = useLocation();

	// Scroll to the top whenever the location changes
	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: 'instant',
		});
	}, [location?.pathname]);

	// Conditionally return navigation or the outlet
	if (isAuthenticated && restricted) {
		return <Navigate to="/" />;
	}

	return <Outlet />;
};

export default PublicRoute;
